import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontMedium, ZeeFontRegular } from 'src/styles/font';

import { MediaBP as MQ } from '../../styles/mediaQuery';

export const ReferralSubscriptionNudge = css`
  text-align: center;
  color: ${colors.PrimaryWhiteColor};

  ${MQ.MediaMd} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const refImage = css`
  padding-top: 10px;
`;

export const refTitleWrapper = css`
  padding-top: 12px;

  ${MQ.MediaLg} {
    padding-top: 16px;
  }
`;

export const title = css`
  ${ZeeFontBold(18, 26)};
  color: ${colors.PrimaryWhiteColor};

  ${MQ.MediaSm} {
    ${ZeeFontBold(24, 36)};
  }

  ${MQ.MediaLg} {
    width: 152px;
    margin: 0 auto;
  }
`;

export const subTitle = css`
  ${ZeeFontRegular(14, 22)};
  color: #e6e2e8;

  ${MQ.MediaSm} {
    ${ZeeFontRegular(16, 24)};
  }

  ${MQ.MediaMd} {
    ${ZeeFontRegular(14, 22)};
  }
`;

export const howItWorks = css`
  margin-top: 52px;
  ${MQ.MediaMd} {
    margin-top: 0px;
  }
`;

export const howItWorkstitle = css`
  ${ZeeFontBold(14, 20)};

  ${MQ.MediaSm} {
    ${ZeeFontBold(16, 22)};
  }

  ${MQ.MediaLg} {
    ${ZeeFontBold(18, 24)};
  }
`;

export const howItWorksDesc = css`
  ${ZeeFontMedium(12, 18)};
  color: #c9c3cf;
  text-align: left;
  margin-top: 28px;
  background: url('/webapp-assets/images/Line-400.svg?ver=getVersion()')
    repeat-y;
  background-position: 12px 0;

  ${MQ.MediaSm} {
    ${ZeeFontMedium(14, 20)};
  }

  ${MQ.MediaLg} {
    ${ZeeFontMedium(16, 22)};
  }
`;

export const counterWrapper = css`
  &:first-of-type {
    padding-top: 0px;
  }

  padding-top: 20px;
  display: flex;
`;

export const counter = css`
  border-radius: 94px;
  background: var(--surface-primary, #0f0617);
  width: 32px;
  height: 32px;
  text-align: center;
  line-height: 32px;
`;
export const counterText = css`
  display: flex;
  align-items: center;
  padding: 4px 8px;
  flex: calc(100% - 40px);
  ${ZeeFontBold(12, 18)};

  ${MQ.MediaSm} {
    ${ZeeFontBold(14, 20)};
  }
`;

export const btn = css`
  color: ${colors.white};
  ${ZeeFontBold(14, 20)};
  height: 38px;
  margin-top: 0px;

  ${MQ.MediaLg} {
    flex: 1;
    width: 50%;
    ${ZeeFontBold(16, 22)};
  }
`;

export const btnContainer = css`
  ${ZeeFontBold(12, 18)};
  color: #a785ff;
  margin-top: 12px;

  ${MQ.MediaLg} {
    flex: 1;
    margin-top: 0px;
    height: 38px;
    ${ZeeFontBold(16, 22)};
  }
`;

export const mayBelaterBtn = css`
  vertical-align: middle;
  height: 32px;
  margin-top: 20px;
  display: block;
  cursor: pointer;

  ${MQ.MediaLg} {
    margin-top: 0px;
    height: 38px;
    line-height: 38px;
  }
`;

export const section = css`
  ${MQ.MediaMd} {
    flex: 1;
  }
`;

export const buttonWrapper = css`
  position: relative;
  margin-top: 48px;

  :global(.referralExitNudge) {
    top: 30px;
    position: relative;
  }

  ${MQ.MediaLg} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;
